import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Lock, ArrowRight } from "lucide-react";
import { api, apiErr } from "../api";
import { AuthShell } from "./Login";

const Field = ({ icon: Icon, ...props }) => (
  <div className="relative">
    <Icon size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-500" />
    <input {...props} className="cc-input w-full rounded-xl pl-10 pr-4 py-3 text-sm" />
  </div>
);

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Passwords do not match"); return; }
    if (password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated — you can log in now");
      navigate("/credit/login");
    } catch (e) {
      toast.error(apiErr(e.response?.data?.detail) || "Reset link is invalid or expired");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Choose a new password"
      subtitle="Enter and confirm your new password"
      footer={<><Link to="/credit/login" className="text-blue-300 hover:text-blue-200">Back to login</Link></>}
    >
      {!token ? (
        <p className="text-sm text-red-300 text-center" data-testid="reset-no-token">This reset link is missing or invalid. Please request a new one.</p>
      ) : (
        <form onSubmit={submit} className="space-y-3.5">
          <Field icon={Lock} type="password" required placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" />
          <Field icon={Lock} type="password" required placeholder="Confirm password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm" />
          <button type="submit" disabled={loading} data-testid="reset-submit" className="cc-btn-primary flex w-full items-center justify-center gap-2 rounded-xl py-3 text-sm font-500 disabled:opacity-60">
            {loading ? "Updating…" : <>Update password <ArrowRight size={16} /></>}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
